/**
 * @fileoverview Commonly used math formulas
 */

import { extent } from 'd3-array'

/**
 * Return the minimum and maximum range required to maintain a given
 * aspect ratio.
 *
 * TODO(nhunzaker): This needs to live inside the scatterplot chart.
 *
 * @param {Array.<number} values
 * @param {number} currentRatio
 * @param {number} idealRatio
 * @returns {Array.<number,number>} A pair of min-max values. Useable by d3.domain
 */
export function maintainAspectRatio(values, currentRatio, idealRatio) {
  let [min, max] = extent(values)

  // Given our ideal aspect ratio, how far off are we from obtaining it?
  // Never expand to fit, so a diff below zero is undesireable
  const diff = Math.max(0, currentRatio - idealRatio) || 0

  // We want to pad equally, so take the difference between the min and max
  // value, then divide by two to apply even padding
  const delta = (max - min) / 2

  // Add the percentage difference to the change and take it away from
  // each end of the domain
  const change = delta * diff

  min -= change
  max += change

  return [min, max]
}

/**
 * Find the middle of two points.
 * @param {{x:number, y:number}} a
 * @param {{x:number, y:number}} b
 * @return {{x:number, y:number}} Middle point
 */
export function midpoint(a, b) {
  return {
    x: (a.x + b.x) / 2,
    y: (a.y + b.y) / 2
  }
}

export function constrain(value, inner, outer, padding) {
  let overflow = outer - (inner + value + padding)

  return Math.max(overflow < 0 ? value + overflow : value, padding)
}

export function sumBy(list, key) {
  return list.reduce((memo, next) => memo + next[key], 0)
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/math.js